(function() {

  zfrespond.views.FieldSelectorView = Backbone.View.extend({

    className: "field-selector-view",

    template: ZFRESPOND_JST.field_selector,

    events: {
      'click .action-select-field': "handleSelectField"
    },

    initialize: function() {
      

      this._templated = false;

      this.listenTo(this.collection, 'add', this.ensureFieldView);

      this.collection.each(_.bind(this.ensureFieldView, this));

      this.fieldSubviews = {};
    },

    render: function() {

      if (!this._templated) {
        this.$el.html(this.template({ }));
      }

      _.each(this.fieldSubviews, function(cid, fieldView) {
        fieldView.render();
      });

      return this;
    },


    ensureFieldView: function(field) {
      var fieldView = this.fieldSubviews[field.cid];
      if (!fieldView) {
        fieldView = this.fieldSubviews[field.cid] = 
                        new zfrespond.views.FieldResponseView({ model:field });
        this.$('.response-container').append(fieldView.$el);
      }
    },


    handleSelectField: function(e) {

      var $field = $(e.currentTarget);
      var fieldId = parseInt($field.attr('data-field-id'));
      var field = this.collection.get(fieldId);

      $field.addClass('selected');

      this.fieldSubviews[field.cid].$el.addClass('selected');
    }

  });

}());